import { render, staticRenderFns } from "./DetailMasterData.vue?vue&type=template&id=4b4414a2"
import script from "./DetailMasterData.vue?vue&type=script&lang=js"
export * from "./DetailMasterData.vue?vue&type=script&lang=js"
import style0 from "./DetailMasterData.vue?vue&type=style&index=0&id=4b4414a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports